<mat-card class="cfiles" >
  <div class="information" *ngIf="!isGroup">
    <h2>Participants</h2>
    <ul>
        <li>
            <div class="icon"><mat-icon>group</mat-icon></div>           
            <span>{{peoples.length}} participants</span>
            <button mat-icon-button  (click)="allParticipants(showParticipants)"><mat-icon>visibility</mat-icon></button>
        </li>
    </ul>
</div>

<!-- <div class="information">
    <h2>Links</h2>
    <ul>
        <li>
            <div class="icon"> <mat-icon >link</mat-icon> </div>
            <span>https://home.servcorp.com/community/message</span>
            <button mat-icon-button ><mat-icon>launch</mat-icon></button>
        </li>
        <li>
            <div class="icon"> <mat-icon >link</mat-icon> </div>
            <span>https://material.io/resources/icons/?icon=launch&style=baseline</span>
            <button mat-icon-button ><mat-icon>launch</mat-icon></button>
        </li>
    </ul>
</div> -->

<div class="information" *ngIf="Files.length >0">
    <h2>Files</h2>
    <ul >
        <li *ngFor="let document of Files">
            <div class="icon" *ngIf="document.fileType == 'pdf'">
               <img src="../../../../assets/icons/fileType/pdf_icon.svg" alt="Pdf File"> 
              </div> 
            <div class="icon" *ngIf="document.fileType == 'doc' || document.fileType == 'docx'"> 
              <img src="../../../../../assets/icons/fileType/doc_icon.svg" alt="Word File">
            </div>
            <div class="icon" *ngIf="document.fileType == 'xlsx' || document.fileType == 'xls' || document.fileType == 'csv' || document.fileType == 'ods'"> 
              <img src="../../../../../assets/icons/fileType/excel_icon.svg" alt="excel File"/>
            </div>   
            <div class="icon" *ngIf="document.fileType == 'jpg' || document.fileType == 'jpeg' || document.fileType == 'image/jpeg'"> 
              <img src="../../../../../assets/icons/fileType/014-jpg.svg" alt="jpg File"/>
            </div> 
            <div class="icon" *ngIf="document.fileType == 'png' || document.fileType == 'gif' || document.fileType == 'tiff' ||
            document.fileType == 'webp' || document.fileType == 'bmp'"> 
            <img src="../../../../../assets/icons/fileType/020-png.svg" alt="png File"/>
            </div>   
            <div class="icon" *ngIf="document.fileType == 'txt'"> 
              <img src="../../../../../assets/icons/fileType/text_icon.svg" alt="txt File"/>
            </div>  
            <div class="icon" *ngIf="document.fileType == 'ppt' || document.fileType == 'pptx'"> 
              <img src="../../../../../assets/icons/fileType/021-ppt.svg" alt="ppt File"/>
            </div>
          
            <div class="icon" *ngIf="document.fileType != 'pdf' &&
            document.fileType != 'doc' && document.fileType != 'docx' &&            
            document.fileType != 'xlsx' && document.fileType != 'xls' && document.fileType != 'csv' && document.fileType != 'ods' &&
            document.fileType != 'jpg' && document.fileType != 'jpeg' && document.fileType != 'image/jpeg' &&
            document.fileType != 'png' && document.fileType != 'gif' && document.fileType != 'tiff' &&
            document.fileType != 'webp' && document.fileType != 'bmp' && 
            document.fileType != 'txt' &&
            document.fileType != 'ppt' && document.fileType != 'pptx'"> 
              <mat-icon class="defaultIcon" >description</mat-icon>
            </div>

            <span>{{document.fileName}}</span>           
            <button mat-icon-button (click)="DownloadFile(document)"><mat-icon>get_app</mat-icon></button>
        </li>       
        <!-- <div class="viewMore">
          <button mat-stroked-button color="primary" >View more</button>
        </div> -->
    </ul>
</div> 

</mat-card>



<ng-template #showParticipants>
    <h2 mat-dialog-title>
       <span class="groupIcon" ><mat-icon>group_add</mat-icon></span>
        Group Participants        
          <button mat-icon-button (click)="close()">
            <mat-icon>close</mat-icon>
          </button>
        </h2>
    
  <mat-dialog-content class="mat-typography">

  
  <ul class="selectedlist">
    <ng-container *ngFor="let user of peoples">
      <li *ngIf="!user.isDeleted">
        <div class="userndetail" >
            <div class="pic"  *ngIf="user.profileImageUrl">
              <img [src]="user.profileImageUrl" alt="" />              
            </div>
            <div class="pic"  *ngIf="!user.profileImageUrl">
              {{getShortName(user.userName)}}
            </div>
            <div class="detail">
                <h4>{{user.userName}}</h4>
                <!-- <p>{{user.email}}</p> -->
            </div>
        </div>
        <div class="option">
          <button mat-icon-button (click)="DeleteUser(user)">
            <mat-icon>delete_outline</mat-icon>
          </button>
        
        </div>
      </li>
    </ng-container>
  </ul>
  
    
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button (click)="close()">Cancel</button>
    <button mat-flat-button color="primary" [disabled]="!doneButtonShow"
    (click)="DeleteParticipant()">Done</button>
  </mat-dialog-actions>
</ng-template>

<div class="progress-loader" *ngIf="spinner">
  <div class="lds-ripple" ><div></div><div></div></div>
</div>



 